import { BookDetails, BookManagement } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for book management in the admin section.
 * @returns {Array} An array containing the route objects for book management.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.BOOK_MANAGEMENT.path,  // URL path for book management
      name: "Book Management",  // Display name for the route
      key: adminRouteMap.BOOK_MANAGEMENT.path,  // Unique key for the route
      private: true,  // Requires authentication to access
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.BOOK_MANAGEMENT.icon,  // Icon associated with book management
      element: <BookManagement />,  // Component to render for book management route
    },
    {
      path: `${adminRouteMap.BOOK_DETAILS.path}/:id`,  // URL path for book details with dynamic book ID
      name: "Book Details",  // Display name for the book details route
      key: `${adminRouteMap.BOOK_DETAILS.path}/:id`,  // Unique key for the book details route
      private: true,  // Requires authentication to access
      element: <BookDetails />,  // Component to render for book details route
    },
  ];
}
